import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Research from "./sections/Research";
import Guides from "./sections/Guides";
import Insights from "./sections/Insights";
import Resources from "./sections/Resources";
import Categories from "./sections/Categories";
import Credibility from "./sections/Credibility";
import Briefing from "./sections/Briefing";
import PrivacyReassurance from "./sections/PrivacyReassurance";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Research />
      <Guides />
      <Insights />
      <Resources />
      <Categories />
      <Credibility />
      <Briefing />
      <PrivacyReassurance />
      <Footer />
    </div>;
}